import React, { Component } from 'react';
import { isMobile, isTablet } from "react-device-detect";

import GoogleMapComponent from '../GoogleMapComponent';


class LocationsMap extends Component {

  state = {
    isGalleryMobileComponent: false,
    isFullscreenMobile: false,
    orientationHorizontalMobile: false,
  };


  componentDidMount() {
    this.props.isGalleryComponent && isMobile && this.setState({ isGalleryMobileComponent: true });
  };


  handleFullscreenMobile = () =>
    this.setState({ isFullscreenMobile: !this.state.isFullscreenMobile });


  render() {
    const { latitude, longitude , googleApiKey, orientationHorizontalMobile } = this.props;
    const { isFullscreenMobile, isGalleryMobileComponent } = this.state;
    const coordinatesObj = { lat: latitude, lng: longitude };
    const containerClass = `map-container${isFullscreenMobile ? ' fullscreen-mobile' : ''}`;


    return (
      <GoogleMapComponent
        containerClass={containerClass}
        coordinates={coordinatesObj}
        googleApiKey={googleApiKey}
        handleFullscreenMobile={this.handleFullscreenMobile}
        isGalleryMobileComponent={isGalleryMobileComponent}
        isFullscreenMobile={isFullscreenMobile}
        isMobile={isMobile && !isTablet}
        orientationHorizontalMobile={orientationHorizontalMobile}
      />
    );
  }
};

export default LocationsMap;
